import apiClient from "../client";

class TokenService {
    
    revokeToken = (token)=>apiClient().post('/revokeToken',{token:token});
    
    verifyToken =(token)=>apiClient().post('/usermanagement/verifyToken',{},{headers:{
        'x-access-token':token
    }});

    getUserToken =( data )=>apiClient('').post('/token',data,{
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            withCredentials: false
        }
    });
}

export default new TokenService();